import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/common/img-pagetop.svg'


const _hoisted_1 = { class: "l-wrapper_nav" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "p-jobsearch-bulkselection_inner" }
const _hoisted_6 = { class: "p-jobsearch-heart js-heart" }
const _hoisted_7 = ["checked"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-heart_icon" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-heart_txt" }, "気になる", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-heart_bubble" }, null, -1)

import { Job } from '@/types';
 // definePropsをインポート
import { domHelperUtils } from '@/utils/domHelper';
import { MYPAGE_CONSTANTS } from '../constants/mypage';


export default /*#__PURE__*/_defineComponent({
  __name: 'JobSearchFooter',
  props: {
    isBulkSelectionEnabled: { type: Boolean },
    jobs: null,
    isLoading: { type: Boolean }
  },
  emits: ['toggleFavorite'],
  setup(__props: any, { emit }) {





function scrollToTop() {
  domHelperUtils.scrollToTop();
}

function onHeartToggle(event: Event){
  const isChecked = (event.target as HTMLInputElement).checked;
  emit('toggleFavorite', {
    isFavorite: isChecked
  });
}




return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("a", {
      class: "g-pagetop",
      href: "#",
      "aria-label": "ページトップへ戻る",
      onClick: _withModifiers(scrollToTop, ["prevent"])
    }, _hoisted_4, 8, _hoisted_2), [
      [_vShow, !__props.isLoading]
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["p-jobsearch-bulkselection p-pending_bulkselection", {'--fixed': __props.isBulkSelectionEnabled}])
    }, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, {
          class: "p-jobsearch-btn __blue __bulkselection",
          to: { path: '/apply/multiple', query: { screen: _unref(MYPAGE_CONSTANTS).SCREN_NAME_MULTI_APPLY.JOBSEARCH ,orderIds: __props.jobs?.filter(v => v.checked).map(v => v.orderId) } }
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 一括応募する ")
          ]),
          _: 1
        }, 8, ["to"]),
        _createElementVNode("label", _hoisted_6, [
          _createElementVNode("input", {
            onChange: onHeartToggle,
            checked: !__props.isBulkSelectionEnabled,
            type: "checkbox"
          }, null, 40, _hoisted_7),
          _hoisted_8,
          _hoisted_9,
          _hoisted_10
        ]),
        _createVNode(_component_router_link, {
          class: "p-jobsearch-btn __do-not-apply",
          to: { path: '/refusal/multiple', query: { orderIds: __props.jobs?.filter(v => v.checked).map(v => v.orderId) } }
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 応募しない")
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ], 2)
  ]))
}
}

})